// every page imports
import 'babel-polyfill';
import 'nodelist-foreach-polyfill';
import './cq';
import './mobile-nav';
import './desktop-nav';
import './required';

// svg-inject-helper
if (document.querySelector('[data-svg-inject]')) {
    import(/* webpackChunkName: "svg-inject-helper" */ './svg-inject-helper').then();
}
// lazy-video
if (document.querySelector('video.lazy')) {
    import(/* webpackChunkName: "lazy-video" */ './lazy-video').then();
}
// lazyload
if (document.querySelector('.lazyload')) {
    import(/* webpackChunkName: "lazysizes" */ 'lazysizes').then();
}
// focuspoint-helper
if (document.querySelector('[data-focus-x]')) {
    import(/* webpackChunkName: "focuspoint-helper" */ './focuspoint-helper').then();
}
// gallery
if (document.querySelector('[data-gallery]')) {
    import(/* webpackChunkName: "gallery" */ './gallery').then();
}
// slideshow
if (document.querySelector('[data-slideshow]')) {
    import(/* webpackChunkName: "slideshow" */ './slideshow').then();
}
// tweet-cleaner
if (document.querySelector('[data-tweet]')) {
    import(/* webpackChunkName: "tweet-cleaner" */ './tweet-cleaner').then();
}
